import { PartnerHero, WhyPartner, PartnershipOptions } from '@/components/sections/partner-page'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const PartnerPage = () => {
  usePageTitle('Partner With Us')

  return (
    <>
      <PartnerHero />
      <WhyPartner />
      <PartnershipOptions />
      <FinalCTA />
    </>
  )
}
